import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import Dropdown from 'components/Luxkit/Dropdown/v2/Dropdown'
import { SearchMenuStates } from 'components/Search/type'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { rem } from 'polished'
import React, { useCallback, useContext, useMemo, useRef } from 'react'
import styled from 'styled-components'
import CruiseLinesSearchList from './CruiseLinesSearchList'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import { useAppSelector } from 'hooks/reduxHooks'

const VendorsDropdown = styled(Dropdown)`
  left: ${rem(0)} !important;
`

function CruiseSearchCruiseLineSelect() {
  const dropdownTriggerRef = useRef<HTMLButtonElement>()

  const { activeMenu, cruiseLines: searchCruiseLines } = useContext(GlobalSearchStateContext)
  const searchDispatch = useContext(GlobalSearchDispatchContext)
  const cruiseLines = useAppSelector(state => state.cruise.cruiseLines)
  const showDropdown = activeMenu === SearchMenuStates.CruiseLines

  const toggleDropdown = useCallback(() => {
    const nextMenu = showDropdown ? SearchMenuStates.Closed : SearchMenuStates.CruiseLines
    searchDispatch({ type: GlobalSearchStateActions.SET_ACTIVE_MENU, menu: nextMenu })
  }, [searchDispatch, showDropdown])

  const cruiseLineNames = useMemo(() => {
    return cruiseLines
      .filter(({ code }) => searchCruiseLines?.includes(code))
      .map(({ name }) => name)
  }, [searchCruiseLines, cruiseLines])

  const vendorName = useMemo(() => {
    const [firstName] = cruiseLineNames
    const more = cruiseLineNames.length > 1 ? `+${cruiseLineNames.length - 1}` : ''
    return firstName && `${firstName} ${more}`
  }, [cruiseLineNames])

  return (
    <>
      <SearchFormField
        onClick={toggleDropdown}
        ref={dropdownTriggerRef}
        label="Cruise lines"
        placeholder="All cruise lines"
        value={vendorName}
      />
      <VendorsDropdown
        triggerRef={dropdownTriggerRef}
        open={showDropdown}
        onClose={toggleDropdown}
        floatingStrategy="absolute"
        width="100%"
        position="bottom-start"
      >
        <DropdownContainer>
          <CruiseLinesSearchList onSelect={toggleDropdown} />
        </DropdownContainer>
      </VendorsDropdown>
    </>
  )
}

export default CruiseSearchCruiseLineSelect
